export enum SampleItemStateType {
  VERIFYING = 'VERIFYING',
  ERROR = 'ERROR',
  NEW = 'NEW',
  INCOMPLETE = 'INCOMPLETE',
  COMPLETE = 'COMPLETE',
  WARNING = 'WARNING',
}
